/* Deskon - "You may also like": keeps the first/second-image pattern correct after the first paint.

   THE RULE ITSELF IS NOT HERE. It lives in snippets/related-grid-order.liquid, the inline script
   rendered right after the grid, which publishes its apply() on window. This file only calls it.

   That split is deliberate. The pattern depends on POSITION, and position only exists after the
   shuffle that same inline script performs - so the two have to run together, before the browser
   paints. An earlier version of this file carried its own copy of the rule and ran as a module,
   which meant it executed after the document was parsed, after the cards were already on screen
   with their original photo. The swap then arrived a moment late: a flicker on a fast load, a
   half-finished pattern if you looked during it. That was the "works one time in two". Retrying
   could not fix it, because the work was not failing - it was happening after the paint.

   Keeping a second implementation here would also have meant two rules to change every time the
   pattern is adjusted, and the desktop diagonal has already been redefined once. There is exactly
   one implementation, and this file is a caller.

   WHAT IT COVERS, which the inline script cannot:

     RESIZE  crossing 750px changes which cards should be swapped - the desktop rule is a diagonal
             over four columns, the mobile rule is a fixed sequence over two. apply() compares the
             wanted state against the recorded one and puts cards back where needed, so this is
             safe to call as often as we like.

     LATE SLIDES  a card whose slideshow-slides is upgraded after the inline script ran is skipped
             by it. The short series of retries catches those, and stops as soon as a pass changes
             nothing.

     THE THEME EDITOR  replaces a section's markup wholesale, taking the inline script's effect
             with it. shopify:section:load re-applies.

   IF window.deskonRelatedOrder IS ABSENT, this file does nothing at all - which is the correct
   failure: it means the inline script did not run, and in that case the shuffle did not run
   either, so there are no positions to honour. */

const GRID = '[data-testid="resource-list-grid"]';
const RETRY_DELAYS = [80, 200, 500, 1200];

function applyAll() {
  const api = window.deskonRelatedOrder;
  if (!api || typeof api.apply !== 'function') return;

  document.querySelectorAll(GRID).forEach((grid) => api.apply(grid));
}

let timers = [];

function runWithRetries() {
  timers.forEach(clearTimeout);
  timers = [];

  applyAll();

  for (const delay of RETRY_DELAYS) {
    timers.push(setTimeout(applyAll, delay));
  }
}

/* Resize fires continuously while a window is dragged; one pass per frame is plenty, and the
   comparison inside apply() makes the repeated calls free when nothing has changed. */
let frame = null;
function onResize() {
  if (frame) cancelAnimationFrame(frame);
  frame = requestAnimationFrame(() => {
    frame = null;
    applyAll();
  });
}

runWithRetries();

window.addEventListener('load', runWithRetries);
window.addEventListener('resize', onResize);
document.addEventListener('shopify:section:load', runWithRetries);
